import { Bubble } from '@lt/components';
import type { ILabel } from '@lt/components/components/Label';
import React from 'react';
import classNames from 'classnames';
import Question from '@lt/components/icons-react/QuestionCircle';

import styles from './hotelCardHeaderLabel.module.css';

const HEADER_LABEL_VARIANTS = {
  1: styles.goldBrown,
  2: styles.bluePurple,
  3: styles.redPink,
  10: styles.brightBlue,
} as const;

type HotelCardHeaderLabelProps = {
  headerLabel?: ILabel;
};

const HotelCardHeaderLabel: React.FC<HotelCardHeaderLabelProps> = ({
  headerLabel,
}) => {
  if (!headerLabel) return null;

  const {
    id,
    icon_path: iconPath,
    title,
    description,
    style = 1,
  } = headerLabel;

  return (
    <Bubble className={styles.styledBubble} text={description}>
      <div
        key={id}
        className={classNames(styles.styledLabel, HEADER_LABEL_VARIANTS[style])}
      >
        {/** TODO: Подумать как избавиться */}
        {iconPath && (
          <div
            className={styles.styledIcon}
            style={{ backgroundImage: `url(${iconPath})` }}
          />
        )}
        <span>{title}</span>
        <div className={styles.icon}>
          <Question className={styles.questionIcon} />
        </div>
      </div>
    </Bubble>
  );
};

export default HotelCardHeaderLabel;
